<template>
    <!-- TODO: Better class name!-->
    <div class="v-atlas-raumplanung-request-options-panel">
        <!--#region Request options controls-->
        <template v-for="(entry, key) in options" :key="key">
            <div :data-help="entry.contextHelpId">
                <h3 v-html="props.options?.[key]?.label" />

                <component :is="componentMap[entry.type]" :option="entry" :model-value="_settings[key]"
                    @update:model-value="emit('update:settings', { ..._settings, [key]: $event })" />
            </div>
        </template>
        <!--#endregion Request Options controls-->
    </div>
</template>


<script setup lang="ts">

import { computed, watch } from 'vue';
import { RequestOptions, RequestSettings } from 'atlas-shared';
import RequestOptionsListItem from './RequestOptionsListItem.vue';
import RequestOptionsAttributeSelectorItem from './RequestOptionsAttributeSelectorItem.vue';

const componentMap: Record<string, any> = {
    List: RequestOptionsListItem,
    AttributeSelector: RequestOptionsAttributeSelectorItem,
};

const props = withDefaults(defineProps<{
    options?: RequestOptions
    settings?: RequestSettings
}>(), {
    options: () => ({}),
    settings: () => ({}),
})

const emit = defineEmits<{
    'update:settings': [settings: any]
}>()

const _settings = computed({
    get: () => props.settings,
    set: (val) => emit('update:settings', val)
})


</script>
